// TaiwanPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import DrpEduNavbar from "../../components/DrpEduNavbar";

const TaiwanPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in Taiwan</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Degree:</strong> Doctor of Philosophy (PhD)
            </li>
            <li>
              <strong>Duration:</strong> 3 to 5 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Master’s degree in a relevant field</li>
                <li>Strong academic record and research proposal</li>
                <li>
                  English proficiency (TOEFL/IELTS may be required for
                  international applicants)
                </li>
              </ul>
            </li>
            <li>
              <strong>Admission Process:</strong>
              <ul>
                <li>
                  Online application with research proposal, CV, recommendation
                  letters, and academic transcripts
                </li>
                <li>Some programs may require an interview</li>
              </ul>
            </li>
            <li>
              <strong>Medium of Instruction:</strong> English or Mandarin (many
              programs offered in English for international students)
            </li>
            <li>
              <strong>Funding Options:</strong>
              <ul>
                <li>
                  Taiwan International Graduate Program (TIGP) – full
                  scholarships
                </li>
                <li>University-specific scholarships (NTU, NCTU, etc.)</li>
                <li>Monthly stipend: NTD 18,000–30,000 (~USD 600–1,000)</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Position:</strong> Postdoctoral Research Fellow / Research
              Associate
            </li>
            <li>
              <strong>Duration:</strong> 1 to 3 years, renewable
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>Completed PhD in a relevant field</li>
                <li>
                  Strong research background with published papers in
                  international journals
                </li>
              </ul>
            </li>
            <li>
              <strong>Funding:</strong>
              <ul>
                <li>Salary: NTD 50,000–80,000/month (~USD 1,600–2,500)</li>
                <li>
                  Funded by the university, Ministry of Science and Technology
                  (MOST), or international collaborations
                </li>
              </ul>
            </li>
            <li>
              <strong>Fields in Demand:</strong> Semiconductors, AI, Biomedical
              Sciences, Renewable Energy, Material Science
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities in Taiwan</h2>
          <ol>
            <li>
              <strong>National Taiwan University (NTU), Taipei</strong> –
              Taiwan’s top-ranked university, strong in engineering, science,
              medicine, and humanities.
            </li>
            <li>
              <strong>National Tsing Hua University (NTHU), Hsinchu</strong> –
              Renowned for science, physics, engineering, and innovation;
              English-taught PhD programs available.
            </li>
            <li>
              <strong>National Yang Ming Chiao Tung University (NYCU)</strong> –
              Formed by the merger of Yang Ming University and Chiao Tung
              University; strong in biomedical sciences, AI, and electronics.
            </li>
            <li>
              <strong>National Cheng Kung University (NCKU), Tainan</strong> –
              Leading in engineering, medical science, and sustainable
              technologies.
            </li>
            <li>
              <strong>Academia Sinica, Taipei</strong> – National research
              academy; hosts TIGP, fully funded PhD and Postdoc positions.
            </li>
            <li>
              <strong>National Central University (NCU), Taoyuan</strong> –
              Research-intensive, known for space science, geophysics, and IT.
            </li>
            <li>
              <strong>
                National Taiwan University of Science and Technology (NTUST)
              </strong>{" "}
              – Also known as Taiwan Tech; focused on applied sciences and
              industrial research.
            </li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default TaiwanPhD;
